export const addDestinationFilterForEvents = (): void => {
  const events = [
    'Broadband Form Loaded',
    'Broadband Form Step Submitted',
    'Broadband Form Submitted',
    'Broadband Product Viewed',
    'Broadband Product List Loaded',
    'Broadband Product Clicked',
    'Broadband Product Clickout',
    'Broadband Promotion Clicked',
    'Element Clicked',
    'Experiment Assigned',
    'Experiment Viewed',
    'Form Errored',
    'Form Loaded',
    'Form Step Submitted',
    'Form Submitted',
    'Product List Loaded',
    'Product List Viewed',
    'Product Viewed',
    'Promotion Viewed'
  ]

  interface AddDestinationFilter {
    payload: {
      name: string
      nerdAttributes: string
    }
    destinations: {
      segment: {
        getEventName: (name: string, nerdAttributes: string) => string
      }
    }
    skip: () => null
  }

  window.nerdEvents?.addDestinationFilter(({ payload, destinations, skip }: AddDestinationFilter) => {
    if (events.includes(destinations.segment.getEventName(payload.name, payload.nerdAttributes))) {
      return [destinations.segment]
    }

    return skip()
  })
}
